/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const safeStringify = (object: Record<any, any>): string => {
	if (!object) {
		return '';
	}
	if (object instanceof Error) {
		return object.stack || object.message;
	}
	return JSON.stringify(object, Object.getOwnPropertyNames(object));
};
